import {IntegrationTypeNum} from 'enums/integrations';

export const getIsGoogleSitesSource = (type: number): boolean => type === IntegrationTypeNum.GOOGLE_SITES_SOURCE;
